// UC20-15 — SYSTEM_ADMIN: every edit of the geography nomenclator, with the
// provenance of each one (wireframe pages/IstoricLocalitati.tsx).
import { useTranslate } from '@tolgee/react';
import { Breadcrumb, PageHeader } from '@simsm/ui-shared';
import { CatalogHistoryLog } from '../../features/history/CatalogHistoryLog';

export function GeographyHistoryPage(): JSX.Element {
  const { t } = useTranslate();

  return (
    <section className="simsm-page simsm-history">
      <div className="simsm-history__breadcrumb">
        <Breadcrumb
          maxVisible={3}
          label={t('common.breadcrumb.aria_label')}
          crumbs={[
            { label: t('geography.title'), to: '/system-admin/geography' },
            { label: t('history.geography.title') },
          ]}
        />
      </div>

      <PageHeader title={t('history.geography.title')} lede={t('history.geography.lede')} />

      <CatalogHistoryLog
        kinds={['GEOGRAPHY']}
        showEntityColumn
        entityColumnLabel={t('history.column.node')}
        searchPlaceholder={t('history.filters.search_placeholder_geography')}
      />
    </section>
  );
}
